window.timer = null;

// Permet d'ignorer les invocations multiples d'une callback avec un timer
export function debounce(callback, wait) {
    clearTimeout(window.timer);
    window.timer = setTimeout(function(){
        callback();
    }, wait);
}
